import { render } from "./global-stock.vue?vue&type=template&id=4db87e72"
import script from "./global-stock.vue?vue&type=script&lang=js"
export * from "./global-stock.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__